import React, { useState } from "react";
import PropTypes from "prop-types";
import { WebEngage, GA, PGAD } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
import { VikatanAsidebar } from "../../rows/ad-free";

const AksPage = ({ data }) => {
  const [name, setName] = useState("");
  const [soulName, setSoulName] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState(false);

  React.useEffect(() => {
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.AKS_PAGE, { collection: data.collection });
    PGAD.loadScript();
  }, []);

  const handleSubmit = () => {
    const r = /\s+/g;
    let first = name.toUpperCase();
    first.replace(r, "");
    let second = soulName.toUpperCase();
    second.replace(r, "");

    if (first !== "" && second !== "") {
      for (var i = 0; i < first.length; i++) {
        for (var j = 0; j < second.length; j++) {
          if (first[i] === second[j]) {
            var a1 = first.substring(0, i);
            var a2 = first.substring(i + 1, first.length);
            first = a1 + a2;
            i = -1;
            var b1 = second.substring(0, j);
            var b2 = second.substring(j + 1, second.length);
            second = b1 + b2;
            j = -1;
            break;
          }
        }
      }

      var ss = first + second;
      var l = ss.length;
      var ar = ["FRIENDS", "LOVER", "AFFECTION", "MARRIAGE", "ENEMY", "SISTER"];
      var stp = 1;

      for (var x = 6; x > 1; x--) {
        var g = (l % x) + stp - 1;
        if (g > x) {
          g = g % x;
        }
        if (g === 0) {
          g = ar.length;
        }
        ar.splice(g - 1, 1);
        stp = g;
        // alert(ar);
      }
      setResult(ar[0]);
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleReset = () => {
    setName("");
    setSoulName("");
    setResult("");
  };

  var anchorLink = "whatsapp://send?text=share with your friends . https://www.vikatan.com/aks?pfrom=whatsapp";

  return (
    <React.Fragment>
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div />
        <div className="page-content infinity-page">
          <div className={`container ${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              <div className={`${styles["flames-div"]}`}>
                <img src="https://media.vikatan.com/vikatan/2021-08/373ef0da-1f6f-4619-8c98-e9de023a349e/aks_banner.png" />
                <div className={`${styles["flames-content"]}`}>
                  <h1>லவ் கால்குலேட்டர் - 90s கிட்ஸ் ஸ்பெஷல் - ஆதலினால் காதல் செய்வீர்</h1>
                  <div className={`${styles["flames-text"]}`}>
                    <p>
                      90ஸ் கிட்ஸ்லாம் இந்தப் பக்கம் வாங்க. நம்ம லவ் ஸ்டோரில முதல் அத்தியாயம் எதுன்னு ஞாபகம் இருக்கா?ஒரு
                      பொண்ணு இல்லை ஆண் மேல லவ் மாதிரி ஒண்ணு வந்துடுச்சுன்னா, போய் லவ்வ சொல்லலாமா, எல்லாத்தயும்
                      மறந்துட்டு தங்கச்சியா இல்ல தம்பியா ஏத்துக்கலாமா, இல்லை கல்யாணத்துக்கு ரெடியான்னு லெட்டர்
                      எழுதலாமான்னு எல்லாத்தையும் முடிவு செஞ்சதே இந்த FLAMES போட்டு பார்த்துதான? நம்முடைய ஜோஸ்யர், கல்யாண
                      புரோக்கர்ன்னு எல்லாமே இந்த FLAMESதான்.
                    </p>
                    <p>
                      ஹூம்… அப்புறம் சொல்ல மறந்துட்டோம்! விகடன் டெலிவிஸ்டாஸ் யூ-ட்யூப் சேனல்ல ஆதலினால் காதல் செய்வீர்னு
                      ஒரு வெப் சீரிஸ் ஆகஸ்ட் 23லேர்ந்து வருது! அது 90’s. 2k கிட்ஸ்னு லவ் ஸ்டோரிதான். Flames போட்டு
                      பார்த்த கையோட அதோட டீஸரையும் பார்த்துடுங்க!
                      <a
                        href="https://www.youtube.com/watch?v=e1hmzzraZM4"
                        target="new"
                        className={`${styles["promo-link"]}`}
                      >
                        https://www.youtube.com/watch?v=e1hmzzraZM4
                      </a>
                    </p>
                  </div>
                  <h2>பெயர்களை ஆங்கிலத்தில் டைப் செய்யுங்கள்</h2>
                  <div className={styles["group"]}>
                    <input
                      value={name}
                      name="name"
                      type="text"
                      onChange={e => {
                        const re = /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/;
                        if (e.target.value === "" || re.test(e.target.value)) {
                          setName(e.target.value);
                        }
                      }}
                    />
                    <input
                      value={soulName}
                      name="partnername"
                      type="text"
                      onChange={e => {
                        const re = /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/;
                        if (e.target.value === "" || re.test(e.target.value)) {
                          setSoulName(e.target.value);
                        }
                      }}
                    />
                  </div>
                  {result && (
                    <div className={styles["result"]}>
                      <span>
                        Relationship status of{" "}
                        <p>
                          {name} and {soulName}
                        </p>
                      </span>
                      <span className={styles["result-txt"]}>{result}</span>
                    </div>
                  )}
                  {error && <div>Please fill all field</div>}

                  <div className={styles["main-buttons"]}>
                    <button onClick={() => handleSubmit()} className={styles["calculate-btn"]}>
                      {" "}
                      Calculate{" "}
                    </button>
                    <button
                      className={styles["reset-btn"]}
                      onClick={() => {
                        handleReset();
                      }}
                    >
                      {" "}
                      Reset{" "}
                    </button>
                  </div>
                  {result && (
                    <div className={styles["main-buttons"]}>
                      <a href={anchorLink} className={styles["whatsapp-btn"]}>
                        Share On WhatsApp
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <aside className={styles.sidebar}>
              <VikatanAsidebar />
            </aside>
          </div>
        </div>

        <div />
      </div>
    </React.Fragment>
  );
};

export { AksPage };

AksPage.propTypes = {
  data: PropTypes.shape()
};
